import { createMapper } from "../../../../../utils/utils";
export const ASSESSMENT_ACTIONS = [
  {
    value: "text",
    label: "Send SMS",
  },
  // {
  //   value: "view_details",
  //   label: "View Details",
  // },
  {
    value: "schedule",
    label: "Schedule",
  },
  {
    value: "mark_reviewed",
    label: "Mark as Reviewed",
  },
];

export const ASSESSMENT_MAIN_TABS = [
  {
    label: "Submitted",
    value: "submitted",
  },
  {
    label: "Sent & Scheduled",
    value: "sent_scheduled",
  },
];

export const SUBMITTED_SUB_TABS = [
  {
    label: "Pending For Review",
    value: "pending_review",
  },
  {
    label: "Reviewed",
    value: "reviewed",
  },
];

export const SEND_SCHEDULED_SUB_TABS = [
  {
    label: "Sent",
    value: "sent",
  },
  {
    label: "Scheduled",
    value: "scheduled",
  },
];

const ASSESSMENT_SEVERITY_LIST = [
  { value: "VERY_LOW", label: "Very Low" },
  { value: "LOW", label: "Low" },
  { value: "MODERATE", label: "Moderate" },
  { value: "HIGH", label: "High" },
  { value: "VERY_HIGH", label: "Very High" },
];

export type AssessmentSeverityValue =
  (typeof ASSESSMENT_SEVERITY_LIST)[number]["value"];

export const ASSESSMENT_SEVERITY_COLOR: Record<
  AssessmentSeverityValue,
  string
> = {
  VERY_LOW: "#00B917",
  LOW: "#00B917",
  MODERATE: "#FFAA00",
  HIGH: "#FF3939",
  VERY_HIGH: "#B71C1C",
};

export const ASSESSMENT_SEVERITY_RECORD = createMapper(
  ASSESSMENT_SEVERITY_LIST
);
